// feature.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/response-api';
import { CrudService } from '../crud-service/crud.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  getAllFeatures() {
    return this._http.get<any[]>(`${this._base }/api/Offer/features`);
  }

  getFeatureUsage() {
    return this._http.get<ApiResponse<any>>(`${this._base}/api/Offer/features/usage`);
  }
}
